import './marketingResources.css'
import React, { useContext, useState, useRef, useEffect } from 'react'
import { ResourceContext } from '../../context/resourceContext/ResourceContext'
import { apiUrl } from '../../context/constants/constants'
import axios from 'axios'
import { useHistory, Link } from 'react-router-dom'
import Posts from '../Posts/Posts'
import PostsByCate from '../PostsByCate/PostsByCate'
import { Container, Grow, Grid, Typography, Button } from '@material-ui/core'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import ColorizeOutlinedIcon from '@mui/icons-material/ColorizeOutlined'
import ListOutlinedIcon from '@mui/icons-material/ListOutlined'
import ViewCompactOutlinedIcon from '@mui/icons-material/ViewCompactOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'

export default function MarketingResources() {
  const {
    resourceState: { resources, resourcesSearch },
    getAllResources,
    filterBySearch
  } = useContext(ResourceContext)
  const [layout, setLayout] = useState(false)
  const [resourceByCateLaser, setResourceByCateLaser] = useState([])
  const [resourceByCateInjection, setResourceByCateInjection] = useState([])
  const filterBySearch2 = (event) => {
    const query = event.target.value
    filterBySearch(resources, query)
  }

  const changeLayout = (layout) => {
    if (layout == 'gird') {
      setLayout(true)
    } else {
      setLayout(false)
    }
  }

  const getAllResourcesByCateLaser = async (cate) => {
    try {
      const res = await axios.get(
        `${apiUrl}/affiliate/getAllResourcesByCate/${cate}`
      )

      setResourceByCateLaser(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  const getAllResourcesByCateInjection = async (cate) => {
    try {
      const res = await axios.get(
        `${apiUrl}/affiliate/getAllResourcesByCate/${cate}`,
        cate
      )
      // console.log(res.data.data)
      setResourceByCateInjection(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllResourcesByCateLaser('Laser')
    getAllResourcesByCateInjection('Injection')
    getAllResources()
  }, [])
  return (
    <Grow in>
      <Container style={{ marginTop: '50px' }}>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapper'
        >
          <Grid item xs={12} sm={12}>
            <div className='marketingResources'>
              <Typography
                className='heading'
                variant='h3'
                style={{ fontWeight: '300', fontSize: '15px' }}
              >
                Marketing Resources
              </Typography>
              <Button className='addResources'>
                <Link
                  to={`${process.env.PUBLIC_URL}/upload-resources`}
                  className='link'
                >
                  <Typography className='uploadResource'>
                    <FileUploadOutlinedIcon />
                    Upload Resources
                  </Typography>
                </Link>
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className='wrapActionResources'>
              <div className='wrapActionResourceLeft'>
                <Button
                  className={!layout ? 'inactive' : 'active'}
                  onClick={() => changeLayout('gird')}
                >
                  <ListOutlinedIcon />
                </Button>
                <Button
                  className={layout ? 'inactive' : 'active'}
                  onClick={() => changeLayout('list')}
                >
                  <ViewCompactOutlinedIcon />
                </Button>
              </div>
              <div className='wrapActionResourceRight'>
                <div className='wrapSearch'>
                  <div className='search-header'>
                    <input
                      id='search-box'
                      placeholder='Search Resources...'
                      onChange={filterBySearch2}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Tabs className={!layout ? 'gird' : 'list'}>
              <TabList>
                <Tab>All Resources</Tab>
                <Tab>
                  Laser <CameraAltOutlinedIcon />
                </Tab>
                <Tab>
                  Injection <ColorizeOutlinedIcon />
                </Tab>
              </TabList>

              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {resourcesSearch && resourcesSearch.length > 0 ? (
                    <Posts data={resourcesSearch} />
                  ) : resources && resources.length > 0 ? (
                    <Posts data={resources} />
                  ) : (
                    'Resources not found!'
                  )}
                  {/* <Posts /> */}
                  {/* <Paper elevation={6}>
                <Paginate page={page} />
              </Paper> */}
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {resourceByCateLaser && resourceByCateLaser.length > 0 ? (
                    <PostsByCate data={resourceByCateLaser} />
                  ) : (
                    'Resources not found!'
                  )}
                  {/* <Posts /> */}
                  {/* <Paper elevation={6}>
                <Paginate page={page} />
              </Paper> */}
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item xs={12} sm={12}>
                  {resourceByCateInjection &&
                  resourceByCateInjection.length > 0 ? (
                    <PostsByCate data={resourceByCateInjection} />
                  ) : (
                    'Resources not found!'
                  )}
                  {/* <Posts /> */}
                  {/* <Paper elevation={6}>
                <Paginate page={page} />
              </Paper> */}
                </Grid>
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}
